import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/periodConfigurations')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/periodConfiguration' })
  },
})
